let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

items.forEach((item) => {
  const summary = item.querySelector("summary");
  summary.addEventListener("click", (e) => {
    e.preventDefault();
    if (item.hasAttribute("open")) {
      item.removeAttribute("open");
    } else {
      item.setAttribute("open", true);
    }
  });
});

var lastScrollTop = 0;
// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener(
  "scroll",
  function () {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      // downscroll code
      $(".custom_search_banner_mobile").removeClass("custom_banner_open");
    } else {
      // upscroll code
      $(".custom_search_banner_mobile").addClass("custom_banner_open");
    }
    lastScrollTop = st;
  },
  false
);

$(".custom_search_banner_mobile").on("click", function (event) {
  $(this).addClass("hidden");
  event.preventDefault();
  $(".header-search-icon-containers .header__search details").prop(
    "open",
    true
  );
   $('.search__input.field__input').focus();
});
$(".custom_search_banner_mobile input").on("click", function (event) {
  event.preventDefault();
  $(".custom_search_banner_mobile").addClass("hidden");
  $(".header-search-icon-containers .header__search details").prop(
    "open",
    true
  );
   $('.search__input.field__input').focus();
  console.log("dasi clickesss 2");
});
$(".custom_search_banner_mobile button").on("click", function (event) {
  event.preventDefault();
  $(".header-search-icon-containers .header__search details").prop(
    "open",
    true
  );
   $('.search__input.field__input').focus();
});

// Header demo search bar hide / show
$(".search-modal__close-button").click((e) => {
  $(".custom_search_banner_mobile").removeClass("hidden");
});
$(".header__icon--search").click((e) => {
  $(".custom_search_banner_mobile").addClass("hidden");
});

document.addEventListener("DOMContentLoaded", (event) => {
  $(".dropdown-menu, .mega-menu").click(function () {
    $(this).toggleClass("open");
  });

  $(".search-close-btn").click(function (e) {
    e.preventDefault();
    var input = $(this).prev();
    input.val("");
    $(this).removeClass("btn-visible");
  });

  $("#Search-In-Modal-1").on("input", function () {
    var inputValue = $(this).val();
    if (inputValue !== "") {
      $(".search-close-btn").addClass("btn-visible");
    } else {
      $(".search-close-btn").removeClass("btn-visible");
    }
  });
});
